import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {BranchOffice} from './branch-office.model';
import * as BranchOfficeActions from './branch-office.actions';

export const branchOfficesFeatureKey = 'branchOffices';

export interface State extends EntityState<BranchOffice> {
  // additional entities state properties
}

export const adapter: EntityAdapter<BranchOffice> = createEntityAdapter<BranchOffice>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(BranchOfficeActions.addBranchOffice,
    (state, action) => adapter.addOne(action.branchOffice, state)
  ),
  on(BranchOfficeActions.upsertBranchOffice,
    (state, action) => adapter.upsertOne(action.branchOffice, state)
  ),
  on(BranchOfficeActions.addBranchOffices,
    (state, action) => adapter.addMany(action.branchOffices, state)
  ),
  on(BranchOfficeActions.upsertBranchOffices,
    (state, action) => adapter.upsertMany(action.branchOffices, state)
  ),
  on(BranchOfficeActions.updateBranchOffice,
    (state, action) => adapter.updateOne(action.branchOffice, state)
  ),
  on(BranchOfficeActions.updateBranchOffices,
    (state, action) => adapter.updateMany(action.branchOffices, state)
  ),
  on(BranchOfficeActions.deleteBranchOffice,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(BranchOfficeActions.deleteBranchOffices,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(BranchOfficeActions.loadBranchOffices,
    (state, action) => adapter.setAll(action.branchOffices, state)
  ),
  on(BranchOfficeActions.clearBranchOffices,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
